'use strict';

import { FormCheck } from './FormCheck.js';
import { scrollToSection, onLoadWindows, scrollToError } from './scrolls.js';
import moment from 'moment';
import * as intlTelInput from 'intl-tel-input';
import * as intlTelInputUtils from 'intl-tel-input/build/js/utils.js';
import { noWorkingDaysSummary, repaintCalendarSummary } from './summary.js';
import Cleave from 'cleave.js';
import { getDatepickerArrow, getLocaleJS } from './main.js';
import { FormMaps } from './FormMaps.js';
import Legaltext from './legalText.js';
import Actions from './Actions.js';

export var datesNoAvailablesSummary = [];

let LEGALTEXT = new Legaltext();
var isSummary = false;
var slotDuration = $('#advisor_slot').val(); //By default
var datesNoAvailables = [];
var noAvailableDays = []
var daySelected = null;
var legalTexts = [];
var actions = new Actions();
var initBrand = '';
var initBranchLegal = '';
var initBranchSch = '';
var initAdvisor = '';
var initClient_type = 0;
var initNIFChar = '';
var discount_codes = [];
var fistChangeCalendar = true;
var minDate = '';
var maxDateAvailable;
export var maxDateAvailableSummary;

export function getAvailableHours(day, hours, slotDuration, summary) {
    var dd = new Date(day);
    var now_utc = new Date(Date.UTC(dd.getFullYear(), dd.getMonth(),
                    dd.getDate(), dd.getHours(),
                    dd.getMinutes(), dd.getSeconds()));
    var d = moment.utc(now_utc).valueOf();

    var data = 'date='+d+"&pavh="+$('#dealer').val()+"&branch_id="+$('#ws-id').val();
    if($('#advisor_id').length>0) {
        data += '&advisor='+$('#advisor_id').val() +'&slot_duration='+slotDuration;
    } else {
        data += '&slot_duration='+$('#ws-slots').val();
    }

    var schedule_hour = '';
    var schedule_date = '';
    var daySelected = '';
    var scheduleDaySelectedFormat = '';
    if($('.summary').length>0){
        schedule_hour = $('#schedule_hour').val();
        schedule_date = $('#schedule_date').val();
        daySelected = $('#datetimePickerDateSummary').data('DateTimePicker').date();
        daySelected = moment(daySelected).format('DD/MM/YYYY');
        scheduleDaySelectedFormat = moment(schedule_date).format('DD/MM/YYYY');
    }

    var that = this;
    $.ajax({
        url: $('#url-base-lang').val()+$('#dealer').val()+"/"+"procesor/getAdvisorDayAvailable",
        data: data,
        type:'POST',
        beforeSend: function() {
            $('.hourPicker .wrap-loader').show();
            $('#divSlotTable').hide();
        },
        success: function(result){	
            $('.hourPicker .wrap-loader').hide();
            $('#divSlotTable').show();
            if(result!='-1') {
                var data = JSON.parse(result);
                var td = "";
                $.each(data, function(i,e) {
                    var date = moment(e.start_date, "DD/MM/YYYY HH:mm:ss").format('HH:mm');
                    var dateDays = moment(e.start_date, "DD/MM/YYYY HH:mm:ss").format('YYYY-MM-DD');
                    var available = (e.occupied==1) ? 'enable-date' : 'available-date';
                    if($('.summary').length>0 && (dateDays == schedule_date) && (date == schedule_hour)) {
                        //day is selected and we need to mark it
                        available += ' selected-date';
                    }
                    var title = (e.occupied==1) ? $('#slot-disabled').val() : $('#slot-enable').val();
                    td += '<button class="btn sch-date '+available+'" title="'+title +'" data-date="'+date+'">'+date+'</button>';
                });
                $('#divSlotTable .slots-btns').html('');
                $('#divSlotTable .slots-btns').append(td);

                $('.slots-btns').on('click', '.available-date', function(e) {
                    e.preventDefault();
                    var time = $(this).attr('data-date');
                    $('#schedule_hour').val(time);

                    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
                    let tempDate = $('#schedule_date').val() + 'T00:00:00';
                    var d = new Date(tempDate);
                    var locale = $('#locale').val();
                    locale = locale.replace("_", "-");
                    var dateString = d.toLocaleDateString(locale, options);
                    
                    $('#appointment_schedule .form-question').hide();
                    var text = dateString + " " + errorsTranslations['appointment_date_to'] + " " + time;
                    $('#appointment_schedule .question-row-collapse').show();
                    $('#appointment_schedule .question-row-collapse .form-answer').show();
                    $('#appointment_schedule .question-row-collapse .form-answer').html(text);
                    $('#appointment_schedule .question-row-collapse .form-question').hide();
                    $('#appointment_schedule .question-row-collapse .form-answer').addClass('content-collapsed');
                    $('#appointment_schedule .form-text-left').addClass('content-collapsed');

                    if($('.summary').length==0) {
                        $('#collapseSchedule').collapse('hide');
                    } else {
                        $('#summary-cancel-changes').show();
                        $('#appointment-summary-continue').prop('disabled',false); 
                    } 
                    $('#appointment_schedule').find('.numberCircle').addClass('inactive');
                    markSelectedDay(time);

                    // goint ot client date
                    $('#appointment_datos').removeClass('section-off');
                    $('#collapseDatos').addClass('show');
                    $('#form-answer-datos').prev("label").addClass('section-active');
                    $('#appointment_datos').removeClass('form-block-inactive').addClass('form-block-active');
                    $('.appointment-section #form-answer-datos').prev("label").each(function() {
                        $(this).addClass('section-active');
                    });

                    $('.slots-btns .available-date').each(function() {
                        $(this).removeClass('selected-date');
                    });
                    $(this).addClass('selected-date');

                    $('#collapseWorkshop').collapse('hide');
                    $('#appointment_workshop .form-question').hide();

                    toggleChevron('#appointment_schedule','#appointment_datos');

                    innactiveSection('#appointment_schedule');

                    if ($('.all-legaltext-container').children().length == 0) {
                        $('.confirm-btn').attr('disabled', false);
                        $('.confirm-btn').removeClass('disabled');
                        $('.confirm-btn').addClass('active');
                    }

                    if(summary==true) {
                        // enable selected
                        if((scheduleDaySelectedFormat === daySelected) && fistChangeCalendar) {
                            $('.slots-btns .sch-date[data-date="'+ schedule_hour + '"]')
                                .removeClass('enable-date')
                                .removeClass('selected-date')
                                .addClass('available-date');
                            fistChangeCalendar = false;
                        }
                    }
                });

                if(summary==true) {
                    isSummary = true;
                    markSelectedDay(hours, true);
                }

            } else {
                $('#divSlotTable .slots-btns').html('');
                var msg = '<div class="noAvailableSlots text-center">'+ errorsTranslations['no_available_slots']+'</div>';
                $('#divSlotTable .slots-btns').append(msg);
                if($('.summary').length>0) {
                    $('#appointment-summary-continue').prop('disabled',true); 
                }
            }
            return false;
        }
    });
}

export function bindAdvisor() {
    //Advisor    
    $('.advisor-type').on('click', function() {
        if($('.summary').length>0) {
            $('#waiting-assessor').hide();
            $('.scheduleBlock').show();
        }
        //remove errors
        $('#error-advisor').find('.error').removeClass('d-block');
        $('#error-advisor').find('.error-msg').html('');
        $('.form-btn-icons-advisor-text').each(function() {
            $('.form-btn-icons-advisor-text').removeClass('advisor-selected');
        });
        $(this).find('.form-btn-icons-advisor-text').addClass('advisor-selected');
        $('#advisor_id').val($(this).attr('data-advisor'));
        $('#advisor_name').val($(this).find('.advisor-name-text').html());
        // $('#advisor_slot').val($(this).attr('data-slot'));
        var text = $(this).find('.advisor-name-text').html();

        $('#appointment_advisor .question-row-collapse .form-answer').html(text);
        $('#appointment-advisor-continue').prop('disabled', false);

        if($('.summary').length>0) {
            if($('#summary-cancel-changes').is(":hidden")) {
                $('#summary-cancel-changes').show();
            }
            $('#btn-change-date').prop('disabled', false);
            $('#appointment-summary-continue').prop('disabled',true); // hem de tornar a seleccionar una data
        }
        getAdvisorMonthAvailable();
    });
}

export function emptyAppointmentTime(){
    //empty string date
    $('.scheduleDateString').html('');
}

export function getAdvisorMonthAvailableSummary() {
    // GET DAYS BY MONTH
    var day = $('#datetimePickerDateSummary').datetimepicker('viewDate');
    var month = day.format('M');
    var year  = day.format('YYYY');
    let firstDayAvailable = '';
    let firstSlots = '';
    datesNoAvailables = [];
    let dataUrl = 'pavh='+$('#dealer').val()+ "&branch_id=" + $('#ws-id').val() + "&month=" + month + "&year=" + year;
    if($('#appointment_advisor_summary').length>0) {
        dataUrl += '&advisor='+$('#advisor_id').val();
    }

    $.ajax({
        url: $('#url-base-lang').val()+$('#dealer').val()+"/"+"procesor/getAdvisorMonthAvailable",
        data: dataUrl, 
        type:'POST',
        beforeSend: function() {
            $('.loader-schedule-row .wrap-loader').show();
            $('.summarySchedule').hide();
        },
        success:function(result){	
            $('.loader-schedule-row .wrap-loader').hide();
            $('.summarySchedule').show();
            maxDateAvailableSummary = "";
            if(result!=='-1') {
                var data = JSON.parse(result);
                if(data.schedules) {
                    $.each(data.schedules, function(i,e) {
                        if(e.occupied==1 || e.occupied==2) {
                            let day = e.date.split(" ");
                            day = day[0];
                            day = moment(day,'DD/MM/YYYY').format('YYYY-MM-DD');
                            datesNoAvailablesSummary.push(day);
                        }
                    });
                }
                if(data.first_available_date && data.first_available_date!='') {
                    firstDayAvailable = moment.unix(data.first_available_date);
                    firstSlots = data.first_available_date_slots;
                } 
            }

            if(firstDayAvailable) {
                let defaultDate =  $('#default_schedule_time').val();
                if(firstDayAvailable.isSame(moment(defaultDate), 'month') && firstDayAvailable.isSame(moment(defaultDate), 'month')) {
                    $('#datetimePickerDateSummary').data('DateTimePicker').date(moment(defaultDate));
                } else {
                    $('#datetimePickerDateSummary').data('DateTimePicker').date(firstDayAvailable);
                }
            }

            if(data.max_date_available && data.max_date_available != '') {
                maxDateAvailableSummary = data.max_date_available;
                $('#datetimePickerDateSummary').data('DateTimePicker').maxDate(moment.unix(maxDateAvailableSummary));
            }

            repaintCalendarSummary(datesNoAvailablesSummary, maxDateAvailableSummary);

            daySelected = $('#datetimePickerDateSummary').data('DateTimePicker').date();

            $('#schedule_date').val(daySelected.format("YYYY-MM-DD"));
            slotDuration = $('#ws-slots').val(); 
            getAvailableHours(daySelected, null, slotDuration, false);
        }
    }) 
}

export function getAdvisorMonthAvailable() {
    // GET DAYS BY MONTH
    var day = $('#datetimePickerDate').datetimepicker('viewDate');
    var month = day.format('M');
    var year  = day.format('YYYY');
    let firstDayAvailable = '';
    let firstSlots = '';
    datesNoAvailables = [];
    var data = 'pavh='+$('#dealer').val()+ "&branch_id=" + $('#ws-id').val() + "&month=" + month + "&year=" + year;
    if($('#appointment_advisor').length>0) {
        data += '&advisor='+$('#advisor_id').val();
    }
    $.ajax({
        url: $('#url-base-lang').val()+$('#dealer').val()+"/"+"procesor/getAdvisorMonthAvailable",
        data: data,
        type:'POST',
        beforeSend: function() {
            $('.loader-schedule-row .wrap-loader').show();
            $('.scheduleBlock').css('display','none');
        },
        success:function(result){	
            $('.loader-schedule-row .wrap-loader').hide();
            $('.scheduleBlock').css('display','flex');
            maxDateAvailable = "";
            if(result!=='-1') {
                var data = JSON.parse(result);
                if(data.schedules) {
                    $.each(data.schedules, function(i,e) {
                        if(e.occupied==1 || e.occupied==2) {
                            let day = e.date.split(" ");
                            day = day[0];
                            day = moment(day,'DD/MM/YYYY').format('YYYY-MM-DD');
                            datesNoAvailables.push(day);
                        }
                    });
                }
                if(data.first_available_date && data.first_available_date!='') {
                    let d = new Date(data.first_available_date * 1000);
                    var now_utc = new Date(d.getUTCFullYear(), d.getUTCMonth(),
                    d.getUTCDate(), d.getUTCHours(),
                    d.getUTCMinutes(), d.getUTCSeconds());

                    var date = new Date(now_utc);
                    firstDayAvailable = moment(date).startOf('day');
                    firstSlots = data.first_available_date_slots;
                } 
                
                if(data.max_date_available && data.max_date_available != '' && data.max_date_available > data.first_available_date) {
                    maxDateAvailable = data.max_date_available;
                    $('#datetimePickerDate').data('DateTimePicker').maxDate(moment.unix(maxDateAvailable));
                }
            }
            $('#datetimePickerDate').data("DateTimePicker").date(firstDayAvailable);
            
            if(data.first_available_date > data.max_date_available){
                repaintCalendar(datesNoAvailables, data.max_date_available, true);
                $('.hourPicker .wrap-loader').hide();
                $('#divSlotTable').show();
                $('#divSlotTable .slots-btns').html('');
                var msg = '<div class="noAvailableSlots text-center">'+ errorsTranslations['no_available_slots']+'</div>';
                $('#divSlotTable .slots-btns').append(msg);
            }else{
                repaintCalendar(datesNoAvailables, maxDateAvailable);
                daySelected = $('#datetimePickerDate').data('DateTimePicker').date();
                $('#schedule_date').val(daySelected.format("YYYY-MM-DD"));
                slotDuration =  $('#ws-slots').val(); 
                getAvailableHours(daySelected, null, slotDuration, false);
            }
        }
    }) 
}

export function repaintCalendar(datesNoAvailables, maxDateAvailable, disableAllDays) {
    var arrayDays = $('#datetimePickerDate tbody td.day');
    $(arrayDays).removeClass('disabled'); 
    if(disableAllDays){
        $(arrayDays).addClass('disabled');
        return;
    } 

    let timeFormatDay = $('#dateTimePattern').val();
    var maxDateFormat = '';
    if(maxDateAvailable && maxDateAvailable != '') {
        var maxDateFormat = moment(moment.unix(maxDateAvailable)).format(timeFormatDay);
        maxDateFormat = maxDateFormat.split(' ');
    }

    $.each(datesNoAvailables, function(i, e) {     
        for(var i = 0; i < arrayDays.length; i += 1) {
            //Deshabilitem els dies concrets retornats per el mètode
            var day = moment(e).format(timeFormatDay);
            day = day.split(' ');
            if (($(arrayDays[i]).attr('data-day') === day[0]) && (!$(arrayDays[i]).hasClass('disabled'))){
                $(arrayDays[i]).addClass('disabled');
            }

            if(maxDateAvailable && maxDateAvailable != '') {
                if(moment($(arrayDays[i]).attr('data-day'),timeFormatDay).isAfter(moment(maxDateFormat,timeFormatDay))
                || moment($(arrayDays[i]).attr('data-day'),timeFormatDay).isSame(moment(maxDateFormat,timeFormatDay).startOf('day'))) {
                    $(arrayDays[i]).addClass('disabled');
                }
            }
        }
    });
}


function markSelectedDay(hour, scroll) {
    $('.slots-btns button').each(function() {
        if($(this).attr('data-date')!==hour) {
            $(this).addClass('day-not-selected');
        } else {
            $(this).removeClass('day-not-selected');
        }
    });
    var dateAttr = '.sch-date[data-date="'+hour+'"]';
    if(hour != undefined && hour != '' && hour != null) {
        if(!$('.summary').length>0) {
            if(scroll) {
                var position = $(dateAttr).offset().top;
                var parent = $('.slots-btns').offset().top;
                $('.slots-btns').animate({
                    scrollTop: (position-parent) - 100
                });
            }  
        }
    } else {
        $('.slots-btns button').each(function() {
            $(this).removeClass('day-not-selected');
        });
    }

}

function toggleChevron(currentContainer, nextContainer) {
    $(currentContainer).find('.fa-chevron-up').removeClass('fa-chevron-up').addClass('fa-chevron-down');
    $(nextContainer).find('.fa-chevron-down').removeClass('fa-chevron-down').addClass('fa-chevron-up');
    if(nextContainer === '#appointment_datos') {
        if($('#appointment_legal_texts').length>0) {
            $('#appointment_legal_texts').find('.fa-chevron-up').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        }
    }
    $('#appointment_legal_texts').find('.fa-chevron-up').removeClass('fa-chevron-up').addClass('fa-chevron-down');
}

function getLegalTexts() {
    var brand_id = $('#appointment_vehicle_brand').select2('data')[0].id;
    var branch_id = $('#ws-id').val();
    var client_type = $('#appointment_client_type').val();
    if (brand_id != initBrand || branch_id != initBranchLegal || client_type != initClient_type) {
        initBranchLegal = branch_id;
        initBrand = brand_id;
        initClient_type = client_type;

        var url = $('#url-base-lang').val()+$('#dealer').val()+"/procesor/getLegalTexts";
        if($('#account_type').val() == 12) {
            url = $('#url-base-lang').val()+$('#dealer').val()+"/procesor/getLegalTextsQuotationDemand";
        }

        $(".all-legaltext-container").hide();
        $('.loader-legal-texts-row .wrap-loader').show();
        $.ajax({
            url: url,
            data: 'branch_id='+branch_id+"&brand_id="+brand_id+"&client_type="+client_type,
            type: 'POST',
            beforeSend: function() {
                $('.confirm-btn').attr('disabled', true);
                $('.confirm-btn').removeClass('active');
                $('.confirm-btn').addClass('disabled');
                $('#appointment_legal_texts').hide();
            },
            success: function(result){
                if (result!='-1') {
                    var IS_JSON = true;
                    try{
                        var obj = JSON.parse(result);
                    }catch(err){
                        IS_JSON = false;
                    } 
                    if(IS_JSON){
                        generateLegalTextsHTML(obj);
                        $('#appointment_legal_texts').show();
                        $('.confirm-btn').attr('disabled', true);
                        $('.confirm-btn').removeClass('active');
                        $('.confirm-btn').addClass('disabled');
                    } else {
                        innactiveSection('#appointment_legal_texts');
                        $('.confirm-btn').attr('disabled', false);
                        $('.confirm-btn').removeClass('disabled');
                        $('.confirm-btn').addClass('active');
                        $('#appointment_validate').removeClass('form-block-inactive').addClass('form-block-active');
                        $('#appointment_legal_texts').hide();
                        $('#appointment-datos-continue').hide();
                        $('#collapseDatos #appointment_validate').show();
                        return false;
                    }
                } else {
                    innactiveSection('#appointment_legal_texts');
                    $('.confirm-btn').attr('disabled', false);
                    $('.confirm-btn').removeClass('disabled');
                    $('.confirm-btn').addClass('active');
                    $('#appointment_validate').removeClass('form-block-inactive').addClass('form-block-active');
                    $('#appointment_legal_texts').hide();
                    $('#appointment-datos-continue').hide();
                    $('#collapseDatos #appointment_validate').show();
                    return false;
                }
                $('.loader-legal-texts-row .wrap-loader').hide();
                return false;
            }
        });
    }
}

function generateLegalTextsHTML(obj) {
    var full_legal_texts = '';
    obj.map(function(page, index) {
        var required_page = 0;
        page.map(function(lt) {
            if (['2', '4', '7', '9'].indexOf(lt['type']) != -1) {
                required_page = 1;
            }
        });

        if (index == 0) {
            full_legal_texts += '<div class="legaltext-page legaltext-page--'+index+'" data-page="'+index+'" data-required="'+required_page+'">';
        } else {
            full_legal_texts += '<div class="legaltext-page legaltext-page--'+index+' hidden" data-page="'+index+'" data-required="'+required_page+'">';
        }

        page.map(function(lt) {
            // Marquem cada text legal si aquest es obligatori o no
            // Ens servira per veure controlar la navegació entre pàgines
            var required_legal = 0;
            if (['2', '4', '7', '9'].indexOf(lt['type']) != -1) {
                required_legal = 1;
            }

            // Mirem si hi ha algun text variable per type != 6 (no text variable)
            var legal_description = lt['legaltext'];
            var input_replace = '';
            input_replace = '<input class="legal-text-input legal-text-input--'+lt['id']+' form-control" type="text">';
            legal_description = legal_description.split('##EDIT##').join(input_replace);
            legal_description = legal_description.split('<a href=').join('<a target="_blank" href=');

            if (['2', '4', '7', '9'].indexOf(lt['type']) != -1) {
                full_legal_texts += '<div class="legaltext-container legaltext-container--'+lt['id']+' required pb-3 mb-3" data-legalid="'+lt['id']+'" data-type="'+lt['type']+'" data-importerid="'+lt['importer_id']+'" data-required="'+required_legal+'">';
            } else {
                full_legal_texts += '<div class="legaltext-container legaltext-container--'+lt['id']+' pb-3 mb-3" data-legalid="'+lt['id']+'" data-type="'+lt['type']+'" data-importerid="'+lt['importer_id']+'" data-required="'+required_legal+'">';
            }

            if (lt['type'] == 2)  {
                full_legal_texts += '<div class="checkboxContent">'+
                                        '<input id="legaltext--'+lt['id']+'" required class="checkbox-button regular-checkbox" type="checkbox">'+
                                        '<label for="legaltext--'+lt['id']+'">'+
                                            '<span class="legaltext-label custom-lbl-cb">'+legal_description+'</span>'+
                                        '</label>'+
                                    '</div>';
            } else if (lt['type'] == 3)  {
                full_legal_texts += '<div class="checkboxContent">'+
                                        '<input id="legaltext--'+lt['id']+'" class="checkbox-button regular-checkbox" type="checkbox">'+
                                        '<label for="legaltext--'+lt['id']+'">'+
                                            '<span class="legaltext-label custom-lbl-cb">'+legal_description+'</span>'+
                                        '</label>'+
                                    '</div>';
            } else if (lt['type'] != 6 && lt['type'] != 9 && lt['type'] != 10) {
                full_legal_texts += '<span class="legaltext-label">'+legal_description+'</span>';
            }

            if (lt.hasOwnProperty('options') && ['4', '5', '7', '8'].indexOf(lt['type']) != -1) {
                full_legal_texts += '<div class="legaltext-options-group--'+lt['id']+' mt-1">';

                if ((lt['type'] == 5 || lt['type'] == 7) && lt['check_all_options'] == 1) {
                    full_legal_texts += '<div class="checkboxContent">'+
                                            '<input id="legaltext-option--all-'+lt['id']+'" data-id="'+lt['id']+'" '+
                                                'data-optionid="all" '+
                                                'class="checkbox-button regular-checkbox check_all_options" type="checkbox">'+
                                            '<label for="legaltext-option--all-'+lt['id']+'">'+
                                                '<span class="legaltext-label-option bold">'+check_all_options+'</span>'+
                                            '</label>'+
                                        '</div>';
                }

                let i = 1;
                for (var key in lt['options']) {
                    var option = '';
                    option = lt['options'][key];
                    var legal_option = option['descripcion'];
                    if (legal_option.indexOf('##EDIT##') != -1) {
                        var input_replace = '<input class="legal-text-input legal-text-input--'+option['id']+' form-control" type="text">';
                        legal_option = legal_option.split('##EDIT##').join(input_replace);
                    }

                    if (lt['type'] == 4) {
                        full_legal_texts += '<div class="radio-input">'+
                                                '<input id="legaltext-option--'+lt['importer_id']+'-'+lt['id']+'-'+option['id']+'" data-id="'+lt['id']+'" '+
                                                    'data-optionid="'+option['id']+'" '+
                                                    'name="legaltext-option--'+lt['importer_id']+'-'+lt['id']+'" '+
                                                    'class="radio-mandatory-button" type="radio" required>'+
                                                '<label class="legaltext-label-option" for="legaltext-option--'+lt['importer_id']+'-'+lt['id']+'-'+option['id']+'">'+legal_option+'</label>'+
                                            '</div>';
                        if (i != lt['options'].length) {
                            full_legal_texts += '<br>';
                        }
                    } else if (lt['type'] == 5) {
                        full_legal_texts += '<div class="checkboxContent">'+
                                                '<input id="legaltext-option--'+lt['importer_id']+'-'+lt['id']+'-'+option['id']+'" data-id="'+lt['id']+'" '+
                                                    'data-optionid="'+option['id']+'" '+
                                                    'class="checkbox-button regular-checkbox legaltext-option" type="checkbox">'+
                                                '<label for="legaltext-option--'+lt['importer_id']+'-'+lt['id']+'-'+option['id']+'">'+
                                                    '<span class="legaltext-label-option">'+legal_option+'</span>'+
                                                '</label>'+
                                            '</div>';
                    } else if (lt['type'] == 7) {
                        full_legal_texts += '<div class="checkboxContent">'+
                                                    '<input id="legaltext-option--'+lt['importer_id']+'-'+lt['id']+'-'+option['id']+'" data-id="'+lt['id']+'" '+
                                                        'data-optionid="'+option['id']+'" '+
                                                        'class="checkbox-mandatory-button regular-checkbox legaltext-option" type="checkbox" required>'+
                                                    '<label for="legaltext-option--'+lt['importer_id']+'-'+lt['id']+'-'+option['id']+'">'+
                                                        '<span class="legaltext-label-option">'+legal_option+'</span>'+
                                                    '</label>'+
                                                '</div>';
                    } else if (lt['type'] == 8) {
                        full_legal_texts += '<div class="radio-input">'+
                                                '<input id="legaltext-option--'+lt['importer_id']+'-'+lt['id']+'-'+option['id']+'" data-id="'+lt['id']+'" '+
                                                    'data-optionid="'+option['id']+'" '+
                                                    'name="legaltext-option--'+lt['importer_id']+'-'+lt['id']+'" '+
                                                    'class="radio-button" type="radio">'+
                                                '<label class="legaltext-label-option" for="legaltext-option--'+lt['importer_id']+'-'+lt['id']+'-'+option['id']+'">'+legal_option+'</label>'+
                                            '</div>';
                        if (i != lt['options'].length) {
                            full_legal_texts += '<br>';
                        }
                    }

                    i++;
                }

                full_legal_texts += '</div>';
            }

            if (lt['type'] == 6) {
                var input_replace = '<input class="legal-text-input legal-text-input--'+lt['id']+' form-control" type="text">';
                var question = lt['question'].split('##EDIT##').join(input_replace);
                full_legal_texts += '<label class="legaltext-label" for="legaltext--'+lt['id']+'">'+question+'</label>'+
                                    '<br>'+
                                    '<textarea id="legaltext--'+lt['id']+'" '+
                                        'class="p-1" '+
                                        'style="border-radius: 3px; border: 1px solid #b5b5b5; width: 100%; height: 50px;">'+
                                            lt['default_text']+
                                    '</textarea>';
            }

            if (lt['type'] == 9 || lt['type'] == 10) {
                full_legal_texts += '<label class="legaltext-label" for="legaltext--'+lt['id']+'">'+legal_description+'</label>'+
                                    '<br>'+
                                    '<div class="w-100">'+
                                        '<canvas id="sig-canvas--'+lt['id']+'" class="p-1 sig-legaltext-canvas" width="300" height="200" data-legaltextid="'+lt['id']+'" required></canvas>'+
                                        '<div class="w-100 text-right">'+
                                            '<button id="clear-canvas" class="btn btn-light" data-legaltextid="'+lt['id']+'"><i class="fas fa-trash-alt"></i></button>'+
                                        '</div>'+
                                    '</div>';
            }

            full_legal_texts += '</div>';
        });

        if (index == 0) {
            full_legal_texts += '<a href="#" class="next-legalpage left js-prev-legalpage hidden" title="'+previous_translation+'">'+
                                    '<i class="fas fa-arrow-circle-left"></i>'+
                                '</a>';
        } else {
            full_legal_texts += '<a href="#" class="next-legalpage left js-prev-legalpage" title="'+previous_translation+'">'+
                                    '<i class="fas fa-arrow-circle-left"></i>'+
                                '</a>';
        }

        if ((index+1) == obj.length) {
            if (required_page == 1) {
                full_legal_texts += '<a href="#" class="next-legalpage right js-final-legal disabled hidden" disabled title="'+next_translation+'">'+
                                      '<i class="fas fa-check-circle"></i>'+
                                    '</a>';
            } else {
                full_legal_texts += '<a href="#" class="next-legalpage right js-final-legal hidden" title="'+next_translation+'">'+
                                      '<i class="fas fa-check-circle"></i>'+
                                    '</a>';
            }
        } else {
            if (required_page == 1) {
                full_legal_texts += '<a href="#" class="next-legalpage right js-next-legalpage disabled" disabled title="'+next_translation+'">'+
                                        '<i class="fas fa-arrow-circle-right"></i>'+
                                    '</a>';
            } else {
                full_legal_texts += '<a href="#" class="next-legalpage right js-next-legalpage" title="'+next_translation+'">'+
                                        '<i class="fas fa-arrow-circle-right"></i>'+
                                    '</a>';
            }
        }

        full_legal_texts += '</div>';

        // FOR NOW WE DON'T WANT THE ##PRICE##
        full_legal_texts = full_legal_texts.split('##PRICE##').join('');

    });

    
    $(".all-legaltext-container").html(full_legal_texts);
    $('.all-legaltext-container').show();
    $('.loader-legal-texts-row .wrap-loader').hide();
    loadCarousel();
}

function loadCarousel() {
    var lastLink = $('.all-legaltext-container').find('.js-final-legal');
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === "class") {
                if (!lastLink.hasClass('disabled')) {
                    $('.confirm-btn').attr('disabled', false);
                    $('.confirm-btn').removeClass('disabled');
                    $('.confirm-btn').addClass('active');
                } else {
                    $('.confirm-btn').attr('disabled', true);
                    $('.confirm-btn').removeClass('active');
                    $('.confirm-btn').addClass('disabled');
                }
            }
        });
    });

    observer.observe(lastLink[0], {attributes: true});

    // LEGALTEXT.setPriceVar();
    LEGALTEXT.assignSignEvents();

    $("#btn-branch-map-confirm").on('click', function() {
        // LEGALTEXT.resetPriceVar();
        LEGALTEXT.backToStart();
    });


    $('.all-legaltext-container').on('click', '.js-prev-legalpage', function(e) {
        e.preventDefault();
        let link = $('.all-legaltext-container').find(this);
        let page = parseInt(link.parents('.legaltext-page').data('page'));
        let prevPage = page - 1;
        $('.all-legaltext-container').find('.legaltext-page--' + page).addClass('hidden');
        $('.all-legaltext-container').find('.legaltext-page--' + prevPage).removeClass('hidden');
        $('.all-legaltext-container').find('.all-legaltext-container').scrollTop(0);
    });

    $('.all-legaltext-container').on('click', '.js-next-legalpage', function(e) {
        e.preventDefault();
        let link = $('.all-legaltext-container').find(this);
        let page = parseInt(link.parents('.legaltext-page').data('page'));
        let pageView = link.parents('.legaltext-page');
        let nextPage = page + 1;

        if (!link.attr('disabled') && pageView.attr('data-required') === "0") {
            $('.all-legaltext-container').find('.legaltext-page--' + page).addClass('hidden');
            $('.all-legaltext-container').find('.legaltext-page--' + nextPage).removeClass('hidden');
            $('.all-legaltext-container').scrollTop(0);

            if ($(".all-legaltext-container").find('.legaltext-page').length == (nextPage + 1) && $('.all-legaltext-container').find('.legaltext-page--' + nextPage).attr('data-required') === "0") {
                $('.all-legaltext-container').find('.js-final-legal').attr('disabled', false);
                $('.all-legaltext-container').find('.js-final-legal').removeClass('disabled');
                $('.all-legaltext-container').find('.js-final-legal').addClass('active');

                $('.confirm-btn').attr('disabled', false);
                $('.confirm-btn').removeClass('disabled');
                $('.confirm-btn').addClass('active');

                $('#appointment_legal_texts .legal-accepted').show();
            }
        }
    });

    // MULTIOPTIONS
    // TYPE = 4 (REQUIRED)
    $('.all-legaltext-container').on('click', '.radio-mandatory-button', function(e) {
        let input = $('.all-legaltext-container').find(this);
        let isRequired = input.attr('required') === 'required';
        let pageView = input.parents('.legaltext-page');
        let legalText = input.parents('.legaltext-container');
        let nextLink = pageView.find('.js-next-legalpage');
        let lastLink = $('.js-final-legal');
        if (nextLink.length === 0) {
            nextLink = pageView.find('.js-final-legal');
        }
        if (isRequired) {
            legalText.attr('data-required', 0);
            if (!LEGALTEXT.hasPageRequired(pageView)) {
                pageView.attr('data-required', 0);
                nextLink.attr('disabled', false);
                nextLink.removeClass('disabled');
                if (!LEGALTEXT.hasLegalRequired() && pageView.attr('data-page') == ($('.legaltext-page').length - 1)) {
                    lastLink.attr('disabled', false);
                    lastLink.removeClass('disabled');
                    lastLink.addClass('active');
                }
            }
        }
    });

    // MULTIOPTIONS
    // TYPE = 8 (OPTIONAL)
    $('.all-legaltext-container').on('click', '.radio-button', function(e) {
        let input = $('.all-legaltext-container').find(this);
        // Actualitzem el checked de l'input
        input.data('checked', true);
    });

    // CHECKBOX UNICS + MULTIOPTIONS
    // TYPE = 2 (REQUIRED) // TYPE = 3 // TYPE = 5 
    $('.all-legaltext-container').on('click', '.checkbox-button', function(e) {
        let input = $('.all-legaltext-container').find(this);
        let pageView = input.parents('.legaltext-page');
        let legalText = input.parents('.legaltext-container');
        let nextLink = pageView.find('.js-next-legalpage');
        let lastLink = $('.all-legaltext-container').find('.js-final-legal');
        if (nextLink.length === 0) {
            nextLink = pageView.find('.js-final-legal');
        }
        let isRequired = input.attr('required') === 'required';
        if (isRequired && (input.prop('checked'))) {
            legalText.attr('data-required', 0);
            if (!LEGALTEXT.hasPageRequired(pageView)) {
                pageView.attr('data-required', 0);
                nextLink.attr('disabled', false);
                nextLink.removeClass('disabled');
                if (!LEGALTEXT.hasLegalRequired() && pageView.attr('data-page') == ($('.legaltext-page').length - 1)) {
                    lastLink.attr('disabled', false);
                    lastLink.removeClass('disabled');
                    lastLink.addClass('active');
                }
            }
            return true;
        }
        if (isRequired && !(input.prop('checked'))) {
            pageView.attr('data-required', 1);
            legalText.attr('data-required', 1);
            nextLink.attr('disabled', true);
            nextLink.addClass('disabled');
            lastLink.attr('disabled', true);
            lastLink.addClass('disabled');
            lastLink.removeClass('active');
        }
    });

    // CHECKBOX MULTIOPTIONS
    // TYPE = 7 (REQUIRED)
    $('.all-legaltext-container').on('change', '.checkbox-mandatory-button', function(e) {
        let input = $('.all-legaltext-container').find(this);
        let isChecked = input.is(':checked');
        let isRequired = input.attr('required') === 'required';
        let pageView = input.parents('.legaltext-page');
        let legalText = input.parents('.legaltext-container');
        let nextLink = pageView.find('.js-next-legalpage');
        let lastLink = $('.all-legaltext-container').find('.js-final-legal');
        if (nextLink.length === 0) {
            nextLink = pageView.find('.js-final-legal');
        }
        let legalContainer = $('.all-legaltext-container').find('.legaltext-container--' + input.data('id'));
        let isLegalRequired = $('.all-legaltext-container').find('.legaltext-container--' + input.data('id')).hasClass('required');

        if (isRequired && isChecked) {
            legalText.attr('data-required', 0);
            if (!LEGALTEXT.hasPageRequired(pageView)) {
                pageView.attr('data-required', 0);
                nextLink.attr('disabled', false);
                nextLink.removeClass('disabled');
                if (!LEGALTEXT.hasLegalRequired() && pageView.attr('data-page') == ($('.legaltext-page').length - 1)) {
                    lastLink.attr('disabled', false);
                    lastLink.removeClass('disabled');
                    lastLink.addClass('active');
                }
            }
            return true;
        }
        // Al desmarcar REQUIRED hem de mirar si ja no hi ha un altre marcat
        if (isRequired && !isChecked) {
            let allChecks = legalContainer.find('.checkbox-mandatory-button');
            let isSomeChecked = false;
            for (let i = 0; i < allChecks.length; i += 1) {
                if ($(allChecks[i]).is(':checked')) {
                    isSomeChecked = true;
                }
            }
            // Si no te cap opcio marcada
            // Si es un text legal obligatori
            if (!isSomeChecked && isLegalRequired) {
                pageView.attr('data-required', 1);
                legalText.attr('data-required', 1);
                nextLink.attr('disabled', true);
                nextLink.addClass('disabled');
                lastLink.attr('disabled', true);
                lastLink.addClass('disabled');
                lastLink.removeClass('active');
            }
        }
    });

    $('.all-legaltext-container').on('click', '#clear-canvas', function(e) {
        e.preventDefault();
        let legalTextId = $('.all-legaltext-container').find(this).data('legaltextid');
        let legalText = $('.all-legaltext-container').find('.legaltext-container--' + legalTextId);
        legalText.attr('data-required', legalText.attr('data-original-required'));
        let canvas = document.getElementById('sig-canvas--' + legalTextId);
        let pageView = $('.all-legaltext-container').find('#sig-canvas--' + legalTextId).parents('.legaltext-page');
        let nextLink = pageView.find('.js-next-legalpage');
        let lastLink = $('.all-legaltext-container').find('.js-final-legal');
        if (nextLink.length === 0) {
            nextLink = pageView.find('.js-final-legal');
        }
        let ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.beginPath();
        LEGALTEXT.canvasPainted = false;
        // Deshabilitem el seguent pas
        if (legalText.attr('data-required') == 1) {
            pageView.attr('data-required', 1);
            nextLink.attr('disabled', true);
            nextLink.addClass('disabled');
            lastLink.attr('disabled', true);
            lastLink.addClass('disabled');
            lastLink.removeClass('active')
        }
    });

    $('.back-to-legal').on('click', function(e) {
        e.preventDefault();
        $('.quotation-legaltext').removeClass('hidden');
        $('.quotation-questions').addClass('hidden');
        LEGALTEXT.backToStart();
    });
}

function innactiveSection(section) {
    $(section).find('.numberCircle').addClass('inactive');
}

$(function() {
    var firstLoading = true;

    if ($('#appointment_client_type').val() == 1) {
        $('.surnames').hide();
        $('.name-text-danger').show();
    }

    $('.branch-selected .branch-select-container').one('DOMSubtreeModified', function() {
        if($('#account_type').val() != 12) {
            $('#ws-slots').val($(this).find('.wf-list-block.selected').attr('data-slot'));
        }
        $('#branch-confirm').show();
    });

    $('#appointment_client_type').on('change', function() {
        getLegalTexts();
        if ($(this).val() == 1) {
            $('.surnames').hide();
            $('.name-text-danger').show();
            return;
        }
        $('.surnames').show();
        $('.name-text-danger').hide();
    });

    // continue btn
    $('.btn-continue').on('click', function() {
        var btnId = $(this).attr('id');
        var formCheck = new FormCheck();

        if(btnId == 'appointment-vehicle-continue') {
            checkSection('appointment-vehicle-continue', true);
        } 
        else if(btnId == 'appointment-reason-continue') {
            $('#appointment_validate').show();

            if ($('#appointment_reason_discount_code').is(':visible') && $('#appointment_reason_discount_code').val() != '') {
                $('#appointment_reason_discount_code').parent().addClass('has-error');
                $('#error-reason .error-msg').html(errorsTranslations['00000_GENERIC_ERROR']);
                $('#error-reason .error').show();
                return;
            }
            $('#error-reason .error .error-msg').html('');
            $('#error-reason .error').hide();
            $('#reason-comments-desktop').removeClass('has-error');
            $('#appointment_reason_discount_code').parent().removeClass('has-error');
            formCheck.checkParams(['checkScript', 'checkOnlyWhiteSpaces'], '#appointment_reason_msg');
            var totalErrorMsg = formCheck.getMsgError();  
            var actionsSelected = actions.getSelectedActions();
            if(actionsSelected.length>0 && totalErrorMsg.length==0) {
                $('#collapseReason').collapse('hide');
                $('#appointment_reason .question-row-collapse').show();
                $('#appointment_reason .question-row-collapse .form-answer').show();
                $('#appointment_reason .question-row-collapse .form-question').hide();
                $('#appointment_reason .question-row-collapse .form-answer').addClass('content-collapsed');
                $('#appointment_reason .form-text-left').addClass('content-collapsed');

                $('.appointment-section #form-answer-workshop').prev("label").each(function() {
                    $(this).addClass('section-active');
                });

                innactiveSection('#appointment_reason');
                
                $('#appointment_reason').trigger("focus");
                $('#appointment_reason').css('height', 'auto');

                if($('#appointment_schedule').length>0) {
                    $('#collapseSchedule').addClass('show');
                    $('#form-answer-schedule').prev("label").addClass('section-active');
                    $('#appointment_schedule').removeClass('form-block-inactive').addClass('form-block-active');
                    $('#appointment_schedule').removeClass('section-off');
                    
                    // close current and open new in chevrons
                    toggleChevron('#appointment_reason','#appointment_schedule');
                } else {
                    $('#collapseDatos').addClass('show');
                    $('#form-answer-datos').prev("label").addClass('section-active');
                    $('#appointment_datos').removeClass('form-block-inactive').addClass('form-block-active');
                    $('#appointment_datos').removeClass('section-off');
                    
                    // close current and open new in chevrons
                    toggleChevron('#appointment_reason','#appointment_workshop');
                    scrollToSection("#appointment_datos");
                }
                
            }  else {
                if(totalErrorMsg.length>0) {
                    var errors = "<ul>";
                    totalErrorMsg.forEach(function(e){
                        errors += '<li>'+e.error+": <i>"+e.fields+'</i></li>';
                    });
                    errors += '</ul>';
                    $('#error-reason').addClass('d-block');
                    $('#error-reason').find('.error').addClass('d-block');
                    $('#error-reason').find('.error-msg').html(errors);
                } else {
                    $('#error-reason .error .error-msg').html(errorsTranslations['reason_mandatory']);
                }
                $('#error-reason .error').show();
            }

            if ($(".all-legaltext-container").find('.legaltext-page').length == 1 && $(".all-legaltext-container").find('.legaltext-page').attr('data-required') === "0") {
                $('.all-legaltext-container').find('.js-final-legal').attr('disabled', false);
                $('.all-legaltext-container').find('.js-final-legal').removeClass('disabled');
                $('.all-legaltext-container').find('.js-final-legal').addClass('active');

                $('.confirm-btn').attr('disabled', false);
                $('.confirm-btn').removeClass('disabled');
                $('.confirm-btn').addClass('active');
            }
        }
        else if(btnId == 'appointment-workshop-map-continue') {
            if($('#account_type').val() != 12 && $('#appointment_advisor').length==0) {
                //$('#advisor_slot').val();
                getAdvisorMonthAvailable();
            }
        }
        else if(btnId == 'btn-branch-map-confirm') {
            if($('#account_type').val() != 12 && $('#appointment_advisor').length==0) {
                getAdvisorMonthAvailable();
            }
        }
        else if(btnId == 'appointment-advisor-continue') {
            $('#error-advisor').find('.error').removeClass('d-block');
            $('#error-advisor').find('.error-msg').html('');
            if($('#advisor_id').val()=='') {
                $('#error-advisor').find('.error').addClass('d-block');
                $('#error-advisor').find('.error-msg').html(errorsTranslations['advisor_is_mandatory']);
            } else {
                $('#collapseAdvisor').collapse('hide');
                $('#appointment_advisor .question-row-collapse').show();
                $('#appointment_advisor .question-row-collapse .form-answer').show();
                $('#appointment_advisor .question-row-collapse .form-question').hide();
                $('#appointment_advisor .question-row-collapse .form-answer').addClass('content-collapsed');
                $('#appointment_advisor .form-text-left').addClass('content-collapsed');
                toggleChevron('#appointment_advisor','#appointment_reason');

                innactiveSection('#appointment_advisor');

                $('#collapseReason').addClass('show');
                $('#form-answer-reason').prev("label").addClass('section-active');
                $('#appointment_reason').removeClass('form-block-inactive').addClass('form-block-active');
                $('#appointment_reason').removeClass('section-off');

                var branch_id = $('.wf-list-block').attr('data-id') ? $('.wf-list-block').attr('data-id') : $('#ws-id').val(); 
                var model = '';
                var model_id = '';
                if($('.vehicle_select_box:visible').length){
                    model = $('#appointment_vehicle_model').select2('data')[0].text;
                    model_id = $('#appointment_vehicle_model').val();
                } else {
                    model = $('#appointment_vehicle_model_name').val();
                }
                var dataSuggested = {
                    branch_id: branch_id,
                    brand_id: $('#appointment_vehicle_brand').val(),
                    plate: $('#appointment_vehicle_plate').val(),
                    model_id: model_id,
                    model: model,
                    pavh: $('#dealer').val()
                }
                $('#collapseReasonMsg .categories-content').empty();
                actions.getSuggestedElements(dataSuggested);
            }
        }
    });

    $('#appointment_vehicle_brand').on('change', function(e, dataModel) {
        $('#appointment_vehicle_model').html('');
		$('.vehicle_insert_box').removeClass('has-error');
		$('.vehicle_insert_box input').val('');
		$.ajax({
			url: $('#url-base-lang').val()+$('#dealer').val()+"/"+"procesor/modelos",
			data:'brand_id='+$(this).val()+"&pavh="+$('#dealer').val(),
			type:'POST',
			beforeSend: function() {
				$('.vehicle_select_box').hide();
				$('.vehicle_insert_box').hide();
				$('#appointment_vehicle_model').hide();
                $('.vehicle-loader-row .wrap-loader').show();
				$('#appointment-vehicle-continue').attr("disabled", true);
                $('#appointment_vehicle_brand').attr("disabled", true);
                
                // reset forms
                onBrandChange(); 
			},	
			success:function(result){
                $('#appointment_vehicle_brand').attr("disabled", false);
				if(result!='-1') {
                    getLegalTexts();
					var data = JSON.parse(result);
					var arrModels = [];
					$.each(data, function(i, e){
						arrModels.push({ id:e.id,text:e.model });
					});
                    $('#appointment_vehicle_model').select2({
                        data: arrModels,
                        width: '100%'
                    });
					if(dataModel) {
						$('#appointment_vehicle_model').val(dataModel.data);
						$('#appointment_vehicle_model').trigger('change'); 
					}
					$('.vehicle_select_box').show();
					$('.vehicle_insert_box').hide();
					$('#appointment_vehicle_model').show();
					$('.vehicle-loader-row .wrap-loader').hide();
                    $('#appointment-vehicle-continue').attr("disabled", false);  
				} 
				else {
					$('.vehicle_select_box').hide();
					$('.vehicle_insert_box').show();
					$('#appointment_vehicle_model').show();
					$('.vehicle-loader-row .wrap-loader').hide();
					$('#appointment-vehicle-continue').attr("disabled", true);
				}
				return false;
			}
		});

        //En cas de tenir-ho activat, mostrem sucursals amb marca oficial
        if ($('#official-branches').val() === '1'){
            //Resetegem el valor de la sucursal seleccionada
            $('#ws-id').val('');
            $('.branch-selected .branch-select-container').html('');
            $('.branch-selected').hide();
            
            if($('#branches-list-map').length > 0) {
                formMaps.getBranches();
            }
            else {
                getBranches();
            }
        }
	});

    $('#appointment_vehicle_model_name').on('keyup paste change', function() {
        $('#appointment-vehicle-continue').attr('disabled', true);
        if ($(this).val() != '') {
            $('#appointment-vehicle-continue').attr('disabled', false);
        }
    })

    function onBrandChange(resetForm = false) {
        if(actions.getPostActions().length > 0 || resetForm) {
            // advise to user!
            $('#collapseWorkshop').removeClass('show');
            $('#collapseAdvisor').removeClass('show');
            $('#collapseReason').removeClass('show');
            $('#collapseDatos').removeClass('show');
            $('#collapseSchedule').removeClass('show');

            $('#appointment_advisor').addClass('form-block-inactive section-off').removeClass('form-block-active');
            $('#appointment_advisor').find('.form-header').removeClass('collapsed');
            $('#appointment_advisor').find('.form-text-left').removeClass('content-collapsed');
            $('#appointment_advisor').find('.question-row-collapse').hide();
            $('#appointment_advisor').find('.form-answer-advisor').html('');

            $('#appointment_reason').addClass('form-block-inactive section-off').removeClass('form-block-active');
            $('#appointment_reason').find('.form-header').removeClass('collapsed');
            $('#appointment_reason').find('.form-text-left').removeClass('content-collapsed');
            $('#appointment_reason').find('.question-row-collapse').hide();
            $('#appointment_reason').find('.form-answer-reason').html('');
            
            $('#appointment_schedule').addClass('form-block-inactive section-off').removeClass('form-block-active');
            $('#appointment_schedule').find('.form-header').removeClass('collapsed');
            $('#appointment_schedule').find('.form-text-left').removeClass('content-collapsed');
            $('#appointment_schedule').find('.question-row-collapse').hide();
            $('#appointment_schedule').find('.form-answer-schedule').html('');
            if($('#appointment_schedule').length>0) {
                $('#appointment_schedule .slots-btns .sch-date').each(function() {
                    $(this).removeClass('selected-date');
                });
            }

            $('#appointment_datos').addClass('form-block-inactive section-off').removeClass('form-block-active');
            $('#appointment_datos').find('.form-header').removeClass('collapsed');
            $('#appointment_datos').find('.form-text-left').removeClass('content-collapsed');
            $('#appointment_datos').find('.question-row-collapse').hide();
            $('#appointment_datos').find('.form-answer-datos').html('');

            if($('#collapseLegalTexts').length>0) {
                $('#collapseLegalTexts').removeClass('show');
            }

            // TOGGLE
            $('#appointment_workshop').find('.fa-chevron-up').removeClass('fa-chevron-up').addClass('fa-chevron-down');
            $('#appointment_advisor').find('.fa-chevron-up').removeClass('fa-chevron-up').addClass('fa-chevron-down');
            $('#appointment_reason').find('.fa-chevron-up').removeClass('fa-chevron-up').addClass('fa-chevron-down');
            $('#appointment_schedule').find('.fa-chevron-up').removeClass('fa-chevron-up').addClass('fa-chevron-down');
            $('#appointment_datos').find('.fa-chevron-up').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        }
        actions.resetActions();
    }

	//when load, call function
	if($('#appointment_vehicle_brand').length>0) {
		loadVehicleModels();
	}
	
	function loadVehicleModels() {
		$.ajax({
			url: $('#url-base-lang').val()+$('#dealer').val()+"/"+"procesor/modelos",
			data:'brand_id='+$('#appointment_vehicle_brand').val()+"&pavh="+$('#dealer').val(),
			type:'POST',
			beforeSend: function() {
				$('.vehicle_select_box').hide();
                $('.vehicle_insert_box').hide();
                $('#appointment_vehicle_model').hide();
				$('.vehicle-loader-row .wrap-loader').show();
				$('#appointment-vehicle-continue').attr("disabled", true);
                $('#appointment_vehicle_brand').attr("disabled", true);
			},
			success:function(result){	
                if(!$('.summary').length>0) {
                    $('#appointment_vehicle_brand').attr("disabled", false);
                }
				if (result!='-1') {
					var data = JSON.parse(result);
					var arrModels = [];
                    var modelExists = !$('#default_model').length;
					$.each(data, function(i, e){
						arrModels.push({ id:e.id,text:e.model });
                        if (e.id == $('#default_model').val()) {
                            modelExists = true;
                        }
					});
                    if (modelExists) {
                        $('#appointment_vehicle_model').select2({
                            data: arrModels,
                            width: '100%'
                        });
                        $('#appointment_vehicle_model').val($('#default_model').val()).trigger('change');
                        $('.vehicle_insert_box').hide();
                        $('.vehicle_select_box').show();
                        $('.vehicle-loader-row .wrap-loader').hide();
                        $('#appointment-vehicle-continue').attr("disabled", false);
                        return;
                    }
                }
                $('.vehicle_insert_box').show();
                $('.vehicle-loader-row .wrap-loader').hide();
                $('#appointment-vehicle-continue').attr("disabled", true);
				$('.vehicle-loader-row .wrap-loader').hide();
				return false;
			}
		});
	}

    $('#collapseWorkshop').on('click', '.wf-list-block-created', function() {
        // cada cop que es clica restart btn
        $('#btn-branch-map-confirm').prop('disabled', false);
        getLegalTexts();
    });

    function checkSection(sectionBtn, goNext) {
        var formCheck = new FormCheck();
        var errors = '';
        var numErrors = 0;
        if(sectionBtn=='appointment-reason-continue') {
            $('#collapseReasonMsg .error .error-msg').html('');
            $('#collapseReasonMsg .error').hide();
            formCheck.checkParams(['checkScript', 'checkOnlyWhiteSpaces'], '#appointment_reason_msg');

            var totalErrorMsg = formCheck.getMsgError();  
            var actionsSelected = actions.getSelectedActions();
            if(actionsSelected.length === 0) {
                $('#collapseReason .error .error-msg').html(errorsTranslations['reason_mandatory']);
                $('#collapseReason .error').show();
                numErrors +=1;
            }
            if(totalErrorMsg.length>0) {
                var errors = "<ul>";
                totalErrorMsg.forEach(function(e){
                    errors += '<li>'+e.error+": <i>"+e.fields+'</i></li>';
                });
                errors += '</ul>';
                numErrors +=1;

                $('#error-reason').addClass('d-block');
                $('#error-reason').find('.error').addClass('d-block');
                $('#error-reason').find('.error-msg').html(errors);
            } else {
                $('#appointment_workshop').removeClass('section-off');
                $('#collapseReason').collapse('hide');
                var text = "";
                if($('#appointment_mail').val()!='') {
                    text = $('#appointment_mail').val();
                } else {
                    text = $('#appointment_tlf').val();
                }
                text = $('#appointment_name').val() + " "+ $('#appointment_surname').val() +  " - " + text;
                $('#form-answer-workshop').show();
                //$('#appointment_datos .form-question').hide();
                if(goNext) {
                    $('#collapseWorkshop').addClass('show');
                    $('#form-answer-workshop').prev("label").addClass('section-active');
                    $('#appointment_workshop').removeClass('form-block-inactive').addClass('form-block-active');
                }

                $('#appointment_datos .question-row-collapse').show();
                $('#appointment_datos .question-row-collapse .form-answer').show();
                $('#appointment_datos .question-row-collapse .form-question').hide();
                if(text != ' - ') {
                    $('#appointment_datos .question-row-collapse .form-answer').html(text);
                }
                $('#appointment_datos .question-row-collapse .form-answer').addClass('content-collapsed');
                $('#appointment_datos .form-text-left').addClass('content-collapsed');
                
                $('.appointment-section #form-answer-workshop').prev("label").each(function() {
                    $(this).addClass('section-active');
                });
                if(goNext) {
                    innactiveSection('#appointment_datos');
                }
            }
        } else if(sectionBtn=='appointment-vehicle-continue') {
            removeErrors('#collapseVehicle', formCheck.errorClass);
            restartError('#error-vehicle');
            restartOK('#ok-vehicle');
            formCheck.checkParams(['checkScript', 'checkPlate', 'checkMandatory'], '#appointment_vehicle_plate');
            formCheck.checkParams(['checkSelect'], '#appointment_vehicle_brand');
            formCheck.checkParams(['checkScript', 'checkNoSymbols'], '#appointment_vehicle_kms');
            formCheck.checkParams(['checkScript', 'checkNoSymbols', 'checkNum'], '#appointment_model_year');
            if($('.vehicle_insert_box:visible').length){
                formCheck.checkParams(['checkMandatory','checkScript', 'checkNoSymbols'], '#appointment_vehicle_model_name');
            } 
            var totalErrorMsg = formCheck.getMsgError();  
            if(totalErrorMsg.length > 0) {
                errors += "<ul>";
                totalErrorMsg.forEach(function(e){
                    errors += '<li>'+e.error+": <i>"+e.fields+'</i></li>';
                });
                errors += '</ul>';
                $('#error-vehicle').addClass('d-block');
                $('#error-vehicle').find('.error').addClass('d-block');
                $('#error-vehicle').find('.error-msg').html(errors);
                numErrors +=1;
            } else {
                $('#error-vehicle').find('.error').removeClass('d-block');
                var brand = $('#appointment_vehicle_brand').select2('data')[0].text;
                var model = '';
                if($('.vehicle_select_box:visible').length){
                    model = $('#appointment_vehicle_model').select2('data')[0].text;
                } else {
                    model = $('#appointment_vehicle_model_name').val();
                }
                var plate = $('#appointment_vehicle_plate').val();
                var text = brand + " " + model + " - " + plate.toUpperCase();
                $('#appointment_workshop').removeClass('section-off');
                $('#collapseVehicle').collapse('hide');
                //$('#appointment_vehicle .form-question').hide();
                $('#form-answer-vehicle').html(text);
                $('#form-answer-vehicle').show();
                if(goNext) {
                    $('#collapseWorkshop').addClass('show');
                    $('#form-answer-workshop').prev("label").addClass('section-active');
                    $('#appointment_workshop').removeClass('form-block-inactive').addClass('form-block-active');
                }
                if(!$('#appointment_vehicle .question-row-collapse').is(':visible')) {
                    $('#appointment_vehicle .question-row-collapse').show();
                    $('#appointment_vehicle .question-row-collapse .form-answer').show();
                    $('#appointment_vehicle .question-row-collapse .form-answer').html(text);
                    $('#appointment_vehicle .question-row-collapse .form-answer').addClass('content-collapsed');
                    $('#appointment_vehicle .form-text-left').addClass('content-collapsed');
                }

                // close current and open new in chevrons
                toggleChevron('#appointment_vehicle','#appointment_workshop');

                $('#appointment_datos #form-answer-datos').prev("label").each(function() {
                    $(this).addClass('section-active');
                });
                if(goNext) {
                    innactiveSection('#appointment_vehicle');
                    $("#appointment_vehicle").focus();
                } 
            }
        }
        else if(sectionBtn=='appointment-datos-continue') {
            removeErrors('#collapseDatos', formCheck.errorClass);
        
            var accountType = $('#account_type').val();
            var clientType = $('#appointment_client_type').val();
            if(accountType == '12') {
                formCheck.checkParams(['checkMandatory','checkOnlyWhiteSpaces', 'checkScript', 'checkNoSymbols'], '#appointment_name');  
                if (clientType == 0) {
                    formCheck.checkParams(['checkMandatory','checkScript', 'checkNoSymbols'], '#appointment_surname');
                    if (country_code != 'GB') {
                        formCheck.checkParams(['checkMandatory','checkOnlyWhiteSpaces', 'checkScript', 'checkNoSymbols'], '#appointment_surname_second');
                    }
                }

                
                if (country_code != 'GB') {
                    formCheck.checkParams(['checkMandatory', 'checkOnlyWhiteSpaces', 'checkScript', 'checkNoSymbols', 'checkAcentos'], '#appointment_dni');
                    if($('#appointment_dni').val() != '')
                        formCheck.checkParamsDNI($('#country-code').val(),clientType);
                }

                formCheck.checkParams(['checkMandatory','checkPhone'], '#appointment_tlf');  
                formCheck.checkParams(['checkMandatory','checkScript', 'checkMail'], '#appointment_mail');  
                
                if($('#appointment_tlf').val()!='') {
                    if(!verifyTelf('#appointment_tlf')) {
                        formCheck.insertError('#appointment_tlf', errorsTranslations['SMS_PROVIDER_ERROR:02029_PHONE_NUMBER_INVALID_FORMAT']);
                    }
                    else {
                        formCheck.checkParams(['checkPhone'], '#appointment_tlf');  
                    }   
                }
            } else {
                if (clientType == 1) {
                    formCheck.checkParams(['checkMandatory', 'checkOnlyWhiteSpaces', 'checkScript', 'checkNoSymbols'], '#appointment_name');  
                } else {
                    formCheck.checkParams(['checkOnlyWhiteSpaces', 'checkScript', 'checkNoSymbols'], '#appointment_name');  
                    formCheck.checkParams(['checkMandatory','checkScript', 'checkNoSymbols'], '#appointment_surname');  

                    if($('#appointment_surname_second').length>0 && country_code != 'GB') {
                        formCheck.checkParams(['checkOnlyWhiteSpaces', 'checkScript', 'checkNoSymbols'], '#appointment_surname_second');  
                    }
                }

                if (country_code != 'GB') {
                    formCheck.checkParams(['checkOnlyWhiteSpaces', 'checkScript', 'checkNoSymbols', 'checkAcentos'], '#appointment_dni');
                    if ($('#appointment_dni').val() != '') 
                        formCheck.checkParamsDNI($('#country-code').val(),clientType);
                }

                //first mirar si email sino telf
                if($('#appointment_tlf').val()!='') {
                    if(!verifyTelf('#appointment_tlf')) {
                       formCheck.insertError('#appointment_tlf', errorsTranslations['SMS_PROVIDER_ERROR:02029_PHONE_NUMBER_INVALID_FORMAT']);
                    }
                    else {
                        formCheck.checkParams(['checkPhone'], '#appointment_tlf');  
                    }   
                }
                if($('#appointment_mail').length>0) {
                    formCheck.checkParams(['checkScript', 'checkMail'], '#appointment_mail');  
                }
                if($('#appointment_mail').val()==='' && $('#appointment_tlf').val()==='') {
                    formCheck.checkMultiple(['#appointment_mail', '#appointment_tlf'], errorsTranslations['MAIL_TLF_MANDATORY']);
                } 
            }

            var totalErrorMsg = formCheck.getMsgError();
            if (totalErrorMsg.length > 0) {
			    errors += "<ul>";
                totalErrorMsg.forEach(function(e){
                    errors += '<li>'+e.error+": <i>"+e.fields.split(' *').join('')+'</i></li>';
                });
                errors += '</ul>';
                $('#error-datos').find('.error').addClass('d-block');
                $('#error-datos').find('.error-msg').html(errors);
                numErrors +=1;
            } 
            else {       
                var text = "";
                if($('#appointment_mail').val()!='') {
                    text = $('#appointment_mail').val();
                } else {
                    text = $('#appointment_tlf').val();
                }
                text = $('#appointment_name').val() + " "+ $('#appointment_surname').val() +  " - " + text;

                $('#appointment_datos .question-row-collapse').show();
                $('#appointment_datos .question-row-collapse .form-answer').show();
                $('#appointment_datos .question-row-collapse .form-answer').html(text);
                $('#appointment_datos .question-row-collapse .form-answer').addClass('content-collapsed');
                $('#appointment_datos .form-text-left').addClass('content-collapsed');

                if(goNext) {
                    innactiveSection('#appointment_datos');
                }

                // if($('#appointment_legal_texts').is(':visible')) {
                //     $('#collapseLegalTexts').collapse('hide');
                //     $('#appointment_legal_texts').removeClass('section-off');
                //     $('#form-answer-legal-texts').show();
                //     $('#form-answer-legal-texts').prev("label").addClass('section-active');
                //     $('#appointment_legal_texts').removeClass('form-block-inactive').addClass('form-block-active');
                //     // $('.appointment-section #form-answer-legal-texts').prev("label").each(function() {
                //     //     $(this).addClass('section-active');
                //     // });
                // } else {
                //     $('#collapseDatos #appointment_validate').show();
                //     //$('#collapseDatos #appointment_validate .confirm-btn').prop('disabled',false);
                // }
            }
        }
        else if(sectionBtn=='appointment-comments-continue') {
            innactiveSection('#appointment_comments');
            if(goNext) {
                $('#collapseComments').collapse('hide');
                $('#appointment_validate').show();
                $('#appointment_validate_header').show();
            }
        }
        return numErrors;
    }

    function removeErrors(parent, error) {
        $('#error-datos').find('.error').removeClass('d-block');
        $('#error-datos').find('.error-msg').html('');
        $(parent).children().find('.form-group').removeClass(error);

        $(parent).children().find('.form-group').each(function() {
            $(this).children().removeClass(error);
        }); 
    }

    //schedule
    var userLang = navigator.language || navigator.userLanguage; 
    var arrows = getDatepickerArrow($('#lang').val());
    var daysDelay = parseInt($('#date-delay').val());
    minDate = moment().format("X");

    var datepickerSchedule = null;
    datepickerSchedule = $('#datetimePickerDate').datetimepicker({
        inline: true,
        sideBySide: false,
        collapse: false,
        format: 'L',
        dayViewHeaderFormat: "MMMM YYYY",
        locale: getLocaleJS(lang),
        icons: {
            previous: arrows.previous,
            next: arrows.next,
        },
        tooltips: {
            today: commonTranslation['datepicker_today'],
            clear: commonTranslation['datepicker_clear'],
            close: commonTranslation['datepicker_close'],
            selectMonth: commonTranslation['datepicker_selectMonth'],
            prevMonth: commonTranslation['datepicker_prevMonth'],
            nextMonth: commonTranslation['datepicker_nextMonth'],
            selectYear: commonTranslation['datepicker_selectYear'],
            prevYear: commonTranslation['datepicker_prevYear'],
            nextYear: commonTranslation['datepicker_nextYear'],
            selectDecade: commonTranslation['datepicker_selectDecade'],
            prevDecade: commonTranslation['datepicker_prevDecade'],
            nextDecade: commonTranslation['datepicker_nextDecade'],
            prevCentury: commonTranslation['datepicker_prevCentury'],
            nextCentury: commonTranslation['datepicker_nextCentury'],
            pickHour: commonTranslation['datepicker_pickHour'],
            incrementHour: commonTranslation['datepicker_incrementHour'],
            decrementHour: commonTranslation['datepicker_decrementHour'],
            pickMinute: commonTranslation['datepicker_pickMinute'],
            incrementMinute: commonTranslation['datepicker_incrementMinute'],
            decrementMinute: commonTranslation['datepicker_decrementMinute'],
            pickSecond: commonTranslation['datepicker_pickSecond'],
            incrementSecond: commonTranslation['datepicker_incrementSecond'],
            decrementSecond: commonTranslation['datepicker_decrementSecond'],
            togglePeriod: commonTranslation['datepicker_togglePeriod'],
            selectTime: commonTranslation['datepicker_selectTime']
        },
    });

    datepickerSchedule.on("dp.change", function (e) {
        slotDuration = $('#ws-slots').val(); //By default
        var daySelected = $('#datetimePickerDate').data('DateTimePicker').date();
        $('#schedule_date').val(daySelected.format("YYYY-MM-DD"));
        if(maxDateAvailable != undefined && maxDateAvailable != '' && daySelected.valueOf()/1000 > maxDateAvailable) return; //per evitar repinti les hores i ens elimini el missatge d'error
        getAvailableHours(daySelected, null, slotDuration, false);
        repaintCalendar(datesNoAvailables, maxDateAvailable)
    });

    datepickerSchedule.on("dp.update", function (e) {
        var currentView = $('#datetimePickerDate').data('DateTimePicker').viewDate();

        // When update datepicker select fist day of month
        datesNoAvailables = [];
        noAvailableDays = [];

        getAdvisorMonthAvailable();
    });

    /* Confirm btn */
    $('.confirm-btn').on('click', function() {
        var errors = 0;

        // Check section vehicle
        errors += checkSection('appointment-vehicle-continue', false); //block 1
        if(errors>0) {
            scrollToSection("#appointment_vehicle");
            $('#page-form .collpase').removeClass('show');
            $('#collapseVehicle').addClass('show');
            return true;
        }

        // Check section reason
        errors += checkSection('appointment-reason-continue', false); //block 3
        if(errors>0) {
            scrollToSection("#appointment_reason");
            $('#page-form .collpase').removeClass('show');
            $('#collapseReason').addClass('show');
            return true;
        }

        errors += checkSection('appointment-datos-continue', false); // last block
        if(errors>0) {
            scrollToSection("#appointment_datos");
            $('#page-form .collpase').removeClass('show');
            $('#collapseDatos').addClass('show');
            return true;
        }

        var replacement_vehicle = ($('#appointment-replace-vehicle').is(':checked')) ? 1 : 0;
        var newDate = Date.parse($('#schedule_date').val() + "T" + $('#schedule_hour').val()+ "Z");
        newDate= newDate/1000;

        var model = "";
        if($('.vehicle_insert_box:visible').length) {
            model = "&model="+$('#appointment_vehicle_model_name').val()+"&model_id="+"";
        }
        else {
            model = "&model_id="+$('#appointment_vehicle_model').val();
        }

        $('#error-validate .error').removeClass('d-block');
        $('#error-validate .error-msg').html('');
        $('.legal_text_check').each(function(index, element) {
            $(element).css('color', '#A3A3A3;');
            $(element).parent().find('.legal_text_check_label').css('color', '#A3A3A3;');
            if (!$(element).is(":checked")) {
                errors++;
                $('#error-validate').show();
                $('#error-validate .error').addClass('d-block');
                $('#error-validate .error-msg').html(errorsTranslations['terms_mandatory']);
                $(element).css('color', '#EE6666;');
                $(element).parent().find('.legal_text_check_label').css('color', '#EE6666;');
            }
        });

        var return_legal_texts = [];
        return_legal_texts = LEGALTEXT.addLegalTexts();

        var actionsSelected = actions.getPostActions();

        if(errors == 0) {
            var data = "type=0&actions="+ encodeURIComponent(JSON.stringify(actionsSelected))+
            "&comments="+$('#appointment_reason_msg').val()+
            "&plate="+$('#appointment_vehicle_plate').val().toUpperCase()+
            "&brand_id="+$('#appointment_vehicle_brand').val()+
            model + 
            "&model_year="+$('#appointment_model_year').val()+
            "&client_type="+$('#appointment_client_type').val()+
            "&firstname="+$('#appointment_name').val();
            if ($('#appointment_client_type').val() == 0) {
                data += "&lastname="+$('#appointment_surname').val()+
                "&secondlastname="+(country_code != 'GB' ? $('#appointment_surname_second').val() : '');
            }
            data += "&vat_number="+(country_code != 'GB' ? $('#appointment_dni').val() : '')+
            "&mobile="+encodeURIComponent(itiClient.getNumber())+
            "&mail="+$('#appointment_mail').val()+
            "&kms="+$('#appointment_vehicle_kms').val()+
            "&replacement_vehicle="+replacement_vehicle+
            '&branch_id='+$('#ws-id').val()+
            "&pavh="+$('#dealer').val()+
            "&legal_texts="+encodeURIComponent(JSON.stringify(return_legal_texts));

            if($('#advisor_id').length>0) {
                data += "&advisor_id="+$('#advisor_id').val();
            }

            if($('#schedule_date').length>0) {
                data += "&start_date="+newDate;
            }

            if($('#account_type').length>0 && $('#account_type').val() == 12) {
                data += "&quotation=1";
            }

            if (discount_codes.length > 0) {
                var aux = [];
                for (var i=0; i<discount_codes.length; i++) {
                    var code = {code:discount_codes[i]};
                    aux.push(code);

                }
                data += "&discount_codes="+encodeURIComponent(JSON.stringify(aux));
            }

            // afegim paràmetres UTM
            var currentParams = new URLSearchParams(window.location.search);
            currentParams.forEach((value, key) => {
                data += "&"+key+"="+value;
            });

            $.ajax({
                url: $('#url-base-lang').val()+$('#dealer').val()+"/form/created",
                data: data,
                type: 'POST',
                beforeSend: function() {
                    $('.confirm-btn').prop('disabled', true);
                    $('.confirm-btn .fa-spinner').show();
                },
                success: function(result) {
                    $('.confirm-btn .fa-spinner').hide();
                    if (result!='-1') {
                        var IS_JSON = true;
                        try{
                            var obj = JSON.parse(result);
                        }catch(err){
                            IS_JSON = false;
                        } 
                        if(IS_JSON){
                            if(obj.hasOwnProperty('msg')) {
                                var error = obj.msg.error;
                                error = error.replace(/\s/g, '');
                                $('#error-validate').show();
                                $('#error-validate .error').addClass('d-block');
                                $('#error-validate .error-msg').html(errorsTranslations[error]);
                                $('.confirm-btn').prop('disabled', false);
                            } else {
                                //tot ok redirect
                                $('.confirm-btn').prop('disabled', true);
                                location.href = $('#url-base-lang').val()+$('#dealer').val()+"/form"+"/"+obj.code;
                            }
                        } else {
                            $('.confirm-btn').prop('disabled', false);
                           return false;
                        }
                    } 
                    return false;
                }
            });
        }
    });

    $('.see-appointment-btn').click(function() {
        $("#page-form").hide();
        $('#page-form-created').hide();
        $('#page-form-summary').show('slow');
        var href = $(this).attr('href');
        $.ajax({
            type: "GET",
            url: href,
            beforeSend: function() {
                $('.page-loader').show();
                $('.page-loader .wrap-loader').show();
                $('#page-form-created').hide();
            },
            success: function(){
                return false;
            }
        });
        return true;
    });

    onLoadWindows();

    $('#btn-search-plate').on('click', function() {
        //input errors too
        removeErrors('#collapseVehicle', 'has-error');
        restartError('#error-vehicle');
        restartOK('#ok-vehicle');
        restartVechicleModel();
        $.ajax({
			url: $('#url-base-lang').val()+$('#dealer').val()+"/"+"procesor/searchPlate",
			data:'plate='+$('#appointment_vehicle_plate').val()+"&pavh="+$('#dealer').val(),
            type:'POST',
            beforeSend: function() {
                $('.loader-row .wrap-loader').show();
                $('#appointment-vehicle-continue').hide();
                $('#brand-model-content').hide();
                $('#btn-search-plate').addClass('disabled');
            },
			success:function(result){	
                $('.loader-row .wrap-loader').hide();
                $('#appointment-vehicle-continue').show();
                $('#vehicle-next').show();
				if(result!='-1') {
                    var data = jQuery.parseJSON(result);
                    $('.ok-row').addClass('d-block');
                    $('#ok-vehicle').find('.ok').addClass('d-block');
                    $('#ok-vehicle').find('.ok-msg').html(errorsTranslations['plate_found']);
                    $('#appointment_vehicle_brand').val(data.brand_id);
                    $('#appointment_vehicle_brand').prop("disabled", true);
                    $('#appointment_vehicle_brand').trigger('change', [{data: data.model_id}]);                 
				} else {
                    //no ha trobat la matricula show msg
                    $('.error-row').addClass('d-block');
                    $('#error-vehicle').find('.error').addClass('d-block');
                    $('#error-vehicle').find('.error-msg').html(errorsTranslations['plate_not_found']);
                }
                $('#brand-model-content').css('display','flex');
                $('#vehicle-next ').show();
                $('#btn-search-plate').removeClass('disabled');
				return false;
			}
		});
    });

    function restartError(errorBlock) {
        $(errorBlock).find('.error').removeClass('d-block');
        $(errorBlock).find('.error-msg').html('');
        $(errorBlock).removeClass('d-block');
    }

    function restartOK(okBlock) {
        $(okBlock).find('.ok').removeClass('d-block');
        $(okBlock).find('.ok-msg').html('');
        $('.ok-row').removeClass('d-block');
    }

    function restartVechicleModel() {
        $('#appointment_vehicle_brand').select2("val", "");
        $('#appointment_vehicle_brand').trigger('change');
    }

    $('.wf-list').on('click', function() {
        clickBranchItem(this);
    });

    $('#appointment_legal_texts').on('change', '.legal_text_check', function() {
        let allChecked = true;
        $(".legal-text-container").find(".legal_text_check").each(function(index, element) {
            if (!$(element).is(":checked")) {
                allChecked = false;
            }
        });
        $('.confirm-btn').prop('disabled', !allChecked);
    });

    $('#appointment_legal_texts').on('click', '.check_all_options', function() {
        var checked = $(this).is(':checked');
        $(this).parents('.legaltext-container').find('.legaltext-option').each(function() {
            $(this).prop('checked', checked);
            $(this).trigger('change');
        });
    });

    $('#appointment_legal_texts').on('click', '.legaltext-option', function() {
        if (!$(this).is('checked')) {
            $(this).parents('.legaltext-container').find('.check_all_options').prop('checked', $(this).is('checked'));
        }
    });

    $('#appointment_dni').on('change keyup paste', function() {
        if ($(this).val().charAt(0) != initNIFChar) {
            initNIFChar = $(this).val().charAt(0);
            getLegalTexts();
        }
    });

    function clickBranchItem(element){
        $('.wf-list').each(function() {
            $(element).removeClass('selected');
        });
        $(element).addClass('selected');
        var wfName = $(element).find('.wf-list-name').html();
        $('#ws-id').val($(element).attr('wf-id'));
        $('#ws-slots').val($(element).attr('wf-slot'));

        if(!$('.summary').length>0) {
            $('#appointment_workshop .question-row-collapse').show();
            $('#appointment_workshop .question-row-collapse .form-answer').html(wfName);
            $('#appointment_workshop .question-row-collapse .form-answer').show();
            $('#appointment_workshop .question-row-collapse .form-question').hide();
            $('#appointment_workshop .question-row-collapse .form-answer').addClass('content-collapsed');
            $('#collapseWorkshop').collapse('hide');
            innactiveSection('#appointment_workshop');

            if($('#appointment_advisor').length>0) {
                scrollToSection("#appointment_advisor");
                $('#collapseAdvisor').addClass('show');
                $('#appointment_advisor').removeClass('form-block-inactive').addClass('form-block-active');
            } else {
                $('#collapseReason').addClass('show');
                $('#form-answer-reason').prev("label").addClass('section-active');
                $('#appointment_reason').removeClass('form-block-inactive').addClass('form-block-active');
                $('#appointment_reason').removeClass('section-off');

                var model = '';
                var model_id = '';
                if($('.vehicle_select_box:visible').length){
                    model = $('#appointment_vehicle_model').select2('data')[0].text;
                    model_id = $('#appointment_vehicle_model').val();
                } else {
                    model = $('#appointment_vehicle_model_name').val();
                }
                var dataSuggested = {
                    branch_id: $('#ws-id').val(),
                    brand_id: $('#appointment_vehicle_brand').val(),
                    plate: $('#appointment_vehicle_plate').val(),
                    model_id: model_id,
                    model: model,
                    pavh: $('#dealer').val()
                }
                $('#collapseReasonMsg .categories-content').empty();
                actions.getSuggestedElements(dataSuggested);
            }
        } else {
            if($('#appointment_advisor').length>0) {
                $('#waiting-assessor').show();
                $('.scheduleBlock').hide();
                $('.scheduleDateString').hide();
                $('#summary-cancel-changes').show();
                $('#schedule_date').val('');
                $('#schedule_hour').val('');
                $('#advisor_id').val('');
                $('#advisor_slot').val('');
                scrollToSection("#appointment_advisor");
            }  
        }

        $('#collapseSchedule').collapse('hide');
        $('#appointment_schedule').addClass('section-off').addClass('form-block-inactive').removeClass('form-block-active');
        $('#appointment_schedule .form-question').hide();
        $('#appointment_schedule .question-row-collapse').show();
        $('#appointment_schedule .question-row-collapse .form-answer').hide();
        $('#appointment_schedule .question-row-collapse .form-answer').html('');
        $('#appointment_schedule .question-row-collapse .form-question').show();
        $('#appointment_schedule .question-row-collapse .form-answer').addClass('content-collapsed');
        $('#appointment_schedule .form-text-left').removeClass('content-collapsed');
        innactiveSection('#appointment_schedule');

        if($('#appointment_advisor').length>0) {
            $('#collapseReason').collapse('hide');
            $('#appointment_reason').addClass('section-off').addClass('form-block-inactive').removeClass('form-block-active');
            $('#appointment_reason .form-question').hide();
            $('#appointment_reason .question-row-collapse').show();
            $('#appointment_reason .question-row-collapse .form-answer').hide();
            $('#appointment_reason .question-row-collapse .form-answer').html('');
            $('#appointment_reason .question-row-collapse .form-question').show();
            $('#appointment_reason .question-row-collapse .form-answer').addClass('content-collapsed');
            $('#appointment_reason .form-text-left').removeClass('content-collapsed');
            innactiveSection('#appointment_reason');
        } else {
            getAdvisorMonthAvailable();
        }
        
        //Do scheduleMethod
        if($('.summary').length>0) {
            noWorkingDaysSummary(true);
        } else {
            if($('#account_type').val() != 12) {
                getLegalTexts();
            }   
        }
        
        if($('#appointment_advisor').length>0) {
            loadAdvisorList();
        }
    }
    
    // Load and call advisors list before pass to next step
    function loadAdvisorList() {
        $('.advissor-error').remove();
        $('#appointment-summary-continue').prop('disabled',false);
        $('#btn-change-date').prop('disabled', false);
        $.ajax({
            url: $('#url-base-lang').val()+$('#dealer').val()+"/"+"procesor/getAdvisorList",
            data: "branch_id="+$('#ws-id').val()+"&pavh="+$('#dealer').val(),
            type:'POST',
            beforeSend: function() {
                $('.loader-advisor-row .wrap-loader').show();
                $('#appointment-advisor-continue').prop('disabled',true);
                if($('.summary').length>0) {
                    $('#appointment-summary-continue').prop('disabled',true);
                    $('#btn-change-date').prop('disabled', true);
                    $('.summary #appointment-advisor-list').html('');
                } else {
                    if(!$('#btn-branch-map-confirm').is(":disabled")) {
                        $('#btn-branch-map-confirm').prop('disabled', true);
                    }
                    if($('.loader-advisor-row .wrap-loader').is(":hidden")) {
                        $('.loader-advisor-row .wrap-loader').show();
                    }
                    $('#btn-branch-map-confirm .fa-spinner').show();
                    $('#btn-branch-map-confirm .branch-continue').hide();
                    $('#btn-branch-map-confirm .branch-loading').show();
                    $('.appointment-options #appointment-advisor-list').html('');
                }
            },
            success: function(result){	
                $('.loader-advisor-row .wrap-loader').hide();
                if(result!='-1') {
                    var IS_JSON = true;
                    try{
                        var obj = JSON.parse(result);
                    }catch(err){
                        IS_JSON = false;
                    } 
                    if(IS_JSON){
                        if(obj) {
                            $('#appointment-advisor-list').show();
                            var advisorList = $('#appointment-advisor-list');
                            $(advisorList).html('');
                            if(obj==-1) {
                                var alertAdvisor = '<div class="col-12 advissor-error pl-medium-0 pr-medium-0">'+
                                '<div class="advissor-error-block">'+ errorsTranslations['workshop_no_advisor']+'</div></div>';
                                $('.branch-list').append(alertAdvisor);
                                $('.advissor-error-block').show();
                                $(".advissor-error").focus();
                                scrollToError(".advissor-error");
                                if($('.summary').length>0) {
                                    $('.summary #appointment-advisor-list').html('');
                                    $('#appointment-summary-continue').prop('disabled',true);
                                    $('#btn-change-date').prop('disabled', true);
                                }
                            } else {
                                // go to next block!!
                                $('.appointment-section #form-answer-advisor').prev("label").each(function() {
                                    $(this).addClass('section-active');
                                });

                                if($('#branches-list-map').length>0) {
                                    $('.branch-advisor-confirm-loader .wrap-loader').hide();  
                                }

                                //go next
                                $('#collapseWorkshop').collapse('hide');
                                $('#btn-branch-map-confirm').prop('disabled', false);
                                $('#btn-branch-map-confirm .fa-spinner').hide();
                                $('#btn-branch-map-confirm .branch-continue').show();
                                $('#btn-branch-map-confirm .branch-loading').hide();
                                
                                $('#collapseAdvisor').addClass('show');
                                $('#appointment_advisor').removeClass('section-off');
                                $('#appointment_advisor').removeClass('form-block-inactive').addClass('form-block-active');
            
                                toggleChevron('#appointment_workshop ','#appointment_advisor');
                                
                                $.each(obj, function(i,e) {
                                    var avatarBlock ="";
                                    if(e.avatar!='') {
                                        avatarBlock = '<div class="advisor-avatar" style="background-image: url('+e.avatar+');"></div>';
                                    } else {
                                        avatarBlock= '<i class="fas fa-user"></i>';
                                    }
                                    var advisorBlock = '<div class="form-icon-advisor-btn-padding a-list">'+
                                    '<button class="form-btn-icons advisor-type" id="btn-advisor-'+e.id+'" data-advisor="'+e.id+'" data-slot="'+e.slot_duration+'">'+
                                    '<div class="form-icon-advisor-content">'+
                                    avatarBlock+
                                    '</div>'+
                                    '<div class="form-btn-icons-advisor-text">'+
                                    '<div class="advisor-info">'+
                                    '<span class="advisor-name-text">'+e.full_name+'</span>'+
                                    '<div class="form-btn-icons-advisor-role">'+
                                    errorsTranslations['advisor_role'] +
                                    '</div>'+
                                    '</div></button></div>';
                                    advisorList.append(advisorBlock);
                                });
                                if($('.summary').lenght>0) {
                                    if($('.summary #advisor_id').val()=="") {
                                        $('#btn-change-date').prop('disabled', true);
                                        $('#appointment-summary-continue').prop('disabled',true);
                                    }
                                } else {
                                    $('#appointment-advisor-continue').prop('disabled',true);
                                }
                                scrollToSection("#appointment_advisor");
                                bindAdvisor();
                            }   
                        } 
                    } 
                } else {
                    var alertAdvisor = '<div class="col-12 advissor-error pl-medium-0 pr-medium-0 mt-2 pl-0 pr-0">'+
                    '<div class="advissor-error-block">'+ errorsTranslations['workshop_no_advisor']+'</div></div>';
                    if($('.branch-list').length>0) {
                        $('.branch-list').append(alertAdvisor);
                    } else {
                        $('.branch-list-container #branch-confirm').append(alertAdvisor);
                    }   
                    $('.branch-advisor-confirm-loader .wrap-loader').hide();               
                    $('.advissor-error-block').show();
                    $(".advissor-error").focus();
                    $('#btn-branch-map-confirm .fa-spinner').hide();
                    $('#btn-branch-map-confirm .branch-continue').show();
                    $('#btn-branch-map-confirm .branch-loading').hide();
                    scrollToError(".advissor-error");
                    if($('.summary').length>0) {
                        $('#appointment-summary-continue').prop('disabled',true);
                        $('#btn-change-date').prop('disabled', true);
                        $('.summary #appointment-advisor-list').html('');
                    } else {
                        if(!$('#appointment_advisor').hasClass('section-off')) {
                            $('#appointment_advisor').addClass('section-off');
                            $('#appointment_advisor #appointment-advisor-list').html('');
                        }
                        if(!$('#appointment_schedule').hasClass('section-off')) {
                            $('#appointment_schedule').addClass('section-off');
                        }
                        $('#collapseWorkshop').addClass('show');
                        $('#collapseAdvisor').removeClass('show');
                        $('#appointment_advisor .form-question').removeClass('section-active');
                        //scrollToSection("#collapseWorkshop");
                    }
                }
            }
        });
    }

    //PHONE NUMBER
    var iti = null; // deprecated
    var itiClient = null;
    var currentCountry = 'es'; //default
    var onlyCountries = [currentCountry];
    
    if($('#page-form').length>0 || $('.created-section').length>0) {
        if($('#appointment_tlf').length>0) {
            phoneInput('#appointment_tlf');
        }
        if($('#branch_tlf').length>0 && $('#branch_tlf').val()!='') {
            phoneInput('#branch_tlf');
        }
    }   

    function verifyTelf(telf) {
        var input = document.querySelector(telf);
        if (input.value.trim()) {
            if(itiClient.isValidNumber()) {
                return true;
            } 
            return false;
        }
    }

    function phoneInput(element) {
        if($('#country-code').length>0 && $('#country-code').val()!='') {
            currentCountry = $('#country-code').val();
            onlyCountries = [currentCountry];
            itiClient = intlTelInput(document.querySelector(element), {
                initialCountry: currentCountry,
                nationalMode: true,
                autoPlaceholder: "off",
                utilsScript: "../../build/js/utils.js"
            });
        } else {
            // call endpoint
            $.getJSON('https://extreme-ip-lookup.com/json/')
            .done(function(data) {
                currentCountry = data.countryCode.toLowerCase();
                onlyCountries = []
                onlyCountries.push(currentCountry);
                itiClient = intlTelInput(document.querySelector(element), {
                    initialCountry: currentCountry,
                    nationalMode: true,
                    autoPlaceholder: "off",
                    utilsScript: "../../build/js/utils.js"
                });
            })
            .fail(function() {
                itiClient = intlTelInput(document.querySelector(element), {
                    initialCountry: currentCountry,
                    nationalMode: true,
                    autoPlaceholder: "off",
                    utilsScript: "../../build/js/utils.js"
                });
            });  
        }
    }

    function phoneInputBranches(element) {
        iti = intlTelInput(document.querySelector(element), {
            nationalMode: true,
            autoPlaceholder: "off",
            utilsScript: "../../build/js/utils.js"
        });
    }

    if($('#appointment_vehicle_kms').length>0) {
        $("#appointment_vehicle_kms").on("keypress keyup blur",function (event) {    
            $(this).val($(this).val().replace(/[^\d].+/, ""));
             if ((event.which < 48 || event.which > 57)) {
                 event.preventDefault();
             }
        });
 
        new Cleave('#appointment_vehicle_kms', {
            numeral: true,
            numeralDecimalMark: '',
            delimiter: '',
        });
    }

    // model year
    $('#datetimepickerModelYear').datetimepicker({
        viewMode: 'years',
        format: 'YYYY',
        useCurrent: false,
        icons: {
            previous: arrows.previous,
            next: arrows.next,
        },
        widgetPositioning: { horizontal: 'auto', vertical: 'bottom' },
    });
    
    $("#appointment_model_year").focus(function () {
        if(!$('#datetimepickerModelYear .bootstrap-datetimepicker-widget').is(":visible")) {
            $('#datetimepickerModelYear').datetimepicker('show');
        }
    });

    var formMaps = new FormMaps();
    
    if($('#appointment_workshop').length>0) {
        $('.mobile-field').each(function(element) {
            phoneInputBranches('#'+$(this).attr('id'));
        });
    }

    mapConfirm();
    function mapConfirm() {
        $('#btn-branch-map-confirm').on('click', function() {
            var wfName = $('.wf-list-block .wf-list-fc .wf-list-name').html();
            var wfId = $('.wf-list-block').attr('data-id');
            var wfSlots = $('.wf-list-block').attr('data-slot');

            if (wfId !== undefined){
                $('.advissor-error-block').hide();
    
                $('#ws-id').val(wfId);
                $('#ws-slots').val(wfSlots);
                $('#appointment_workshop .form-question').hide();
        
                // reset schedule title
                $('#appointment_schedule .question-row-collapse').hide();
                $('#appointment_schedule .question-row-collapse .form-answer').hide();
                $('#appointment_schedule .question-row-collapse .form-answer').html('');
                $('#appointment_schedule .form-question').show();
        
                $('#appointment_workshop .question-row-collapse').show();
                $('#appointment_workshop .question-row-collapse .form-answer').html(wfName);
                $('#appointment_workshop .question-row-collapse .form-answer').show();
                $('#appointment_workshop .question-row-collapse .form-question').hide();
                $('#appointment_workshop .question-row-collapse .form-answer').addClass('content-collapsed');
                $('#appointment_workshop .form-text-left').addClass('content-collapsed');
        
                innactiveSection('#appointment_workshop');
                
                // si no hi ha advisor consultem els working days aqui
                if(!$('#appointment_advisor').length>0) {
                    $('#collapseWorkshop').collapse('hide');
                    $('#collapseReason').addClass('show');
                    $('#appointment_reason').removeClass('section-off');
                    $('#appointment_reason').removeClass('form-block-inactive').addClass('form-block-active');
                    toggleChevron('#appointment_workshop','#appointment_reason');
                    var model = '';
                    var model_id = '';
                    if($('.vehicle_select_box:visible').length){
                        model = $('#appointment_vehicle_model').select2('data')[0].text;
                        model_id = $('#appointment_vehicle_model').val();
                    } else {
                        model = $('#appointment_vehicle_model_name').val();
                    }
                    //load categories
                    var dataSuggested = {
                        branch_id: wfId,
                        brand_id: $('#appointment_vehicle_brand').val(),
                        plate: $('#appointment_vehicle_plate').val(),
                        model_id: model_id,
                        model: model,
                        pavh: $('#dealer').val()
                    }
                    $('#collapseReasonMsg .categories-content').empty();
                    actions.getSuggestedElements(dataSuggested);
                }  else {
                    loadAdvisorList();
                }
        
                //getFirstDate();
                getLegalTexts();
        
                if($('.advissor-error .advissor-error-block').length>0) {
                    $('.advissor-error .advissor-error-block').remove();
                }
            }
            else {
                //No tenim sucursal seleccionada
                $('#wf-error-search').show();
                $('#wf-error-search .error').show();
                $('#wf-error-search .error .error-msg').html($('#wf-branch-not-found').val());
            }
        });    
    }


    $('.btn-action-quantity-add').on('click', function() {
        actions.addActionQuantity(this, true);
    });

    $('.btn-action-quantity-substract').on('click', function() {
        actions.subtractActionQuantity(this);
    });

    // Blocks collapse
    $('.form-content').on('show.bs.collapse', function () {
        var that = $(this);
        if($('.summary').length>0) {
            // close all clocks
            $('.form-content').each(function() {
                if(that != $(this) && $(this).find('.form-content-desplegate').hasClass('show')) {
                    $(this).find('.form-content-desplegate').removeClass('show');
                    $(this).find('.fa-chevron-up').removeClass('fa-chevron-up').addClass('fa-chevron-down');
                }
            });
        }
        $(this).find('.fa-chevron-down').removeClass('fa-chevron-down').addClass('fa-chevron-up');
    });

    $('.form-content').on('hide.bs.collapse', function () {
        $(this).find('.fa-chevron-up').removeClass('fa-chevron-up').addClass('fa-chevron-down');
    });

    $('.discount-code-check').on('click', function(e) {
        e.preventDefault();
        var btn = this;
        $(btn).attr('disabled', true);
        $('#error-reason .error').hide();
        $('#appointment_reason_discount_code').parent().removeClass('has-error');

        if (discount_codes.indexOf($('#appointment_reason_discount_code').val()) >= 0) {
            $('#appointment_reason_discount_code').parent().addClass('has-error');
            $('#error-reason .error-msg').html(errorsTranslations['00010_ELEMENT_ALREADY_EXISTS']);
            $('#error-reason .error').show();
            $(btn).removeAttr('disabled');
            return;
        }

        var formCheck = new FormCheck();
        formCheck.checkParams(['checkScript', 'checkOnlyWhiteSpaces'], '#appointment_reason_discount_code');
        var errors = formCheck.getMsgError();
        
        if (errors.length > 0 || $('#appointment_reason_discount_code').val() == '') {
            $('#appointment_reason_discount_code').parent().addClass('has-error');
            $('#error-reason .error-msg').html(errorsTranslations['00000_GENERIC_ERROR']);
            $('#error-reason .error').show();
            $(btn).removeAttr('disabled');
            return;
        }

        var discount_code = $('#appointment_reason_discount_code').val();
        $.ajax({
            url: $('#url-base-lang').val()+$('#dealer').val()+'/procesor/validate_code',
            data: 'code='+discount_code+"&pavh="+$('#dealer').val(),
            type: 'POST',
            success: function(result) {
                $(btn).removeAttr('disabled');
                var IS_JSON = true;
                try{
                    var obj = JSON.parse(result);
                }catch(err){
                    IS_JSON = false;
                } 
                if(IS_JSON){
                    if (obj.success == true) {
                        discount_codes.push(discount_code);
                        $('#appointment_reason_discount_code').val('');
                        var code_tag = '<div class="code-tag" data-value="'+discount_code+'">'+discount_code+'&nbsp;<button type="button" class="close" aria-label="Close"><span aria-hidden="true">×</span></button></div>';
                        $('#code-list').append(code_tag);
                        if (!$('.code-list-container').is(':visible')) {
                            $('.code-list-container').show();
                        }
                        return;
                    }
                }

                $('#error-reason .error-msg').html(errorsTranslations['00008_ELEMENT_NOT_FOUND']);
                $('#error-reason .error').show();
                $('#appointment_reason_discount_code').parent().addClass('has-error');
                return;
            }
        });
    });

    $('#appointment_reason_discount_code').on('keyup', function(e) {
        if (e.originalEvent.keyCode == '13') {
            $('.discount-code-check').trigger('click');
        }
    })

    let trigger = 'hover';
    if($(document).width()<1000) {
        trigger = 'manual';
    }

    $(document).on('click', '.code-tag .close', function() {
        var code_tag = $(this).parents('.code-tag');
        var index = discount_codes.indexOf($(code_tag).attr('data-value'));

        if (index > -1) {
          discount_codes.splice(index, 1);
        }

        $(code_tag).remove();

        if (discount_codes.length == 0) {
            $('.code-list-container').hide();
        }
    });

    if ($('.code-tag').length > 0) {
        $('.code-tag').each(function(i, l) {
            discount_codes.push($(l).attr('data-value'));
        });
    }

    $('#budgetModal').on('show.bs.modal', function (e) {
        $('#collapseReason .b-body [data-toggle=popover]').each(function(i, obj){
            $(this).popover('dispose');
        });

        $('.budget-cloned').html('');
        $('.budget-cloned').html($('.budget-container .b-body').clone(true, true));
        
        $(".budget-cloned [data-toggle=popover]").each(function(i, obj) {
            $(this).popover({
                html: true,
                sanitize: false,
                trigger: trigger
            }).on('click', function(e) {
                $(this).popover('toggle');
            });
        });
    })

    $('#budgetModal').on('hide.bs.modal', function (e) {
        $('.budget-cloned [data-toggle=popover]').each(function(i, obj){
            $(this).popover('dispose');
        });
        $("#collapseReason .b-body [data-toggle=popover]").each(function(i, obj) {
            $(this).popover({
                html: true,
                sanitize: false,
                trigger: trigger
            }).on('click', function(e) {
                $(this).popover('toggle');
            });
        });

    });

    function getBranches(){
        var branches = [];

        var data = "pavh="+$('#dealer').val();
        if ($('#official-branches').val() === '1'){
            data += '&brand_id='+$('#appointment_vehicle_brand').val();
        }

        $('#collapseWorkshop .branch-list').html('');
        $('#collapseWorkshop .branch-loader .loader-branches-row .wrap-loader').show();

        $.ajax({
            url: $('#url-base-lang').val()+$('#dealer').val()+"/"+"form/branchList",
            data: data,
            type:'POST',
            success: function(result) {
                if(result!='-1' && result!='') {
                    var IS_JSON = true;
                    try{
                        var obj = JSON.parse(result);
                    }catch(err){
                        IS_JSON = false;
                    } 
                    if(IS_JSON){
                        $('#error-advisor .error').hide();
                        $('#error-advisor .error .error-msg').html('');

                        obj.forEach(element => {
                            branches.push(element);
                        });

                        if(branches.length > 0) {
                            paintBranches(branches);
                        } else {
                            //show message no branches
                        }
                    }
                } else {
                    $('#collapseWorkshop .branch-loader .loader-branches-row .wrap-loader').hide();
                    $('#error-advisor').show();
                    $('#error-advisor .error').show();
                    $('#error-advisor .error .error-msg').html($('#wf-branch-not-found').val());
                }
            }
        })
    }

    function paintBranches(elements) {
        $('#collapseWorkshop .branch-loader .loader-branches-row .wrap-loader').hide();

        // Esborrem dades de sucursal
        $('#ws-id').val('');
        $('#advisor_id').val('');

        onBrandChange(true);
        if ($('#appointment_workshop .question-row-collapse .form-answer').hasClass('content-collapsed')) {
            $('#appointment_workshop .question-row-collapse').hide();
            $('#appointment_workshop .question-row-collapse .form-answer').html('');
            $('#appointment_workshop .question-row-collapse .form-answer').hide();
            $('#appointment_workshop .question-row-collapse .form-question').show();
            $('#appointment_workshop .question-row-collapse .form-answer').removeClass('content-collapsed');

            $('#appointment_advisor').addClass('section-off');
            $('#appointment_advisor #appointment-advisor-list').html('');

            scrollToSection("#appointment_advisor");
            $('#collapseWorkshop').addClass('show');    
        }
       
        elements.forEach(element => {
            var block = '<div class="wf-list d-flex" wf-id="'+element.id+'" wf-slot="'+element.slot_duration+'">';
            block += '<div class="wf-list-row wf-list-fc wf-list-map-icon col-1"><i class="fas fa-map-marker-alt"></i></div>';
            block += '<div class="col-11">';
            block += '<div class="wf-list-name wf-list-fc">'+element.name+'</div>';
            block += '<div class="wf-list-row wf-list-sc">'+element.address+', '+element.postal_code+' '+element.city+'</div>';
            block += '<div class="wf-list-tc w-100 mobile-field-disabled">';

            if (element.telephone != '')
                block += '<input type="text" id="mobile-field-'+element.id+'" disabled class="form-control mobile-field" value="'+element.telephone+'"/>';

            block += '</div></div></div>';

            $('#collapseWorkshop .branch-list').append(block);
        });

        $('.wf-list').on('click', function() {
            clickBranchItem(this);
        });
    }

});